var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    { attrs: { "app-name": "cookbook" } },
    [
      _c("AppContent", [
        _c("div", { staticClass: "main" }, [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "message" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.t("cookbook", "Cannot access recipe folder.")) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    // prettier-ignore
                    _vm.t("cookbook", "You are logged in with a guest account. Therefore, you are not allowed to generate arbitrary files and folders on this Nextcloud instance. To be able to use the Cookbook app as a guest, you need to specify a folder where all recipes are stored. You will need write permission to this folder."                            )
                  ) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectFolder.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.t("cookbook", "Select recipe folder")) +
                      "\n                    "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }